import { fmt, MobileTimePicker, Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import React from 'react'

const TimePickerInput = props => {
  const { value, defaultValue, onChange, inputVariant, ...rest } = props

  const date = value || defaultValue
  const initialDate = Moment.isValid(date, fmt.hour) ? Moment.pure(date, fmt.hour) : null
  const [selectedDate, setSelectedDate] = React.useState(initialDate)

  const handleDateChange = value => {
    if (!value) {
      setSelectedDate(null)
    } else {
      setSelectedDate(value)
      if (onChange) {
        const formattedDate = value.format(fmt.hour)
        onChange(formattedDate)
      }
    }
  }

  return (
    <MobileTimePicker
      {...rest}
      value={selectedDate}
      defaultValue={selectedDate}
      onChange={handleDateChange}
      ampm={false}
      invalidDateMessage={Translate({ messageKey: 'invalid_date_format' })}
      minDateMessage={Translate({ messageKey: 'date_before_minimal' })}
      maxDateMessage={Translate({ messageKey: 'date_after_maximal' })}
      cancelLabel={Translate({ messageKey: 'cancel' })}
      clearLabel={Translate({ messageKey: 'clear' })}
      clearable
      inputVariant={inputVariant}
      slotProps={{
        textField: {
          fullWidth: true,
          slotProps: { inputLabel: { shrink: true } },
          variant: 'standard',
        },
      }}
    />
  )
}

export default TimePickerInput
